var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1154 0.413837C16.3789 0.173351 16.7256 0.0397465 17.0862 0.0531065C17.4468 0.0531065 17.7796 0.186711 18.0431 0.440558C18.2928 0.681044 18.4453 1.01505 18.4453 1.36242C18.4453 1.70979 18.3205 2.0438 18.0709 2.29765L10.2212 9.85962C10.0964 9.97986 9.94383 10.0734 9.77741 10.1402C9.61099 10.207 9.43069 10.2471 9.2504 10.2471C9.07011 10.2471 8.88982 10.207 8.70952 10.1402C8.5431 10.0734 8.39054 9.97986 8.26573 9.85962L0.41606 2.29765C0.291242 2.17741 0.180292 2.03044 0.110949 1.87012C0.0416056 1.69643 -3.81352e-07 1.52275 -3.88944e-07 1.34906C-3.96536e-07 1.17538 0.0277369 0.988334 0.0970803 0.828009C0.166424 0.667685 0.277373 0.52072 0.402191 0.387116C0.527009 0.266873 0.693433 0.173351 0.859857 0.106549C1.02628 0.0263872 1.20657 -0.000333839 1.40073 -0.000333847C1.58103 -0.000333855 1.76132 0.0397472 1.92774 0.106549C2.09417 0.173351 2.24672 0.280233 2.38541 0.413837L9.2504 7.02722L10.5402 5.77135L16.1154 0.413837Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.eac486b6f829b4c0281f2d409b897661.svg";
export { ForwardRef as ReactComponent };